/**
 * A function to create a log object for the 'aClickUpmCtaEvent' event (evid: 500)
 *
 * Event description: UOU click on Update Payment Method for a single subscription
 *
 * @param {aClickUpmCtaEventParams} params - The parameters for this event
 * @property {DateTime} previousBillingDate - The previous date the subscription was charged at
 * @property {DateTime} nextBillingDate - The next date the subscription is scheduled to be charged at
 * @property {string} subscription_status - Current status of subscription
 * @property {GUID} subscriptionId - The subscription that the UOU is looking to update
 * @property {boolean} cycleAutoRenew - Flag indicating if the subscription will be canceled at the next cycle (at next_billing_date)
 * @property {number} cycle - Current cycle of subscription
 * @property {GUID} paymentMethodId - The current payment method before the update
 * @property {GUID} sessionId - The session of UPM flow, can be multiple sessions for the same visitor (uou)
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<aClickUpmCtaEventParams>} LogObject<aClickUpmCtaEventParams>
 */
export function aClickUpmCtaEvent(params) {
    return { evid: 500, src: 128, endpoint: 'my-subscriptions', params: params };
}
/**
 * A function to create a log object for the 'aClickCancelUpmEvent' event (evid: 502)
 *
 * Event description: UOU cancel the update payment method widget
 *
 * @param {aClickCancelUpmEventParams} params - The parameters for this event
 * @property {GUID} subscriptionId - The subscription that the UOU is looking to update
 * @property {string} referral - "Cancel Button" or Exit Window (click X or click in random place in screen)
 * @property {GUID} sessionId - The session of UPM flow, can be multiple sessions for the same visitor (uou)
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<aClickCancelUpmEventParams>} LogObject<aClickCancelUpmEventParams>
 */
export function aClickCancelUpmEvent(params) {
    return { evid: 502, src: 128, endpoint: 'my-subscriptions', params: params };
}
/**
 * A function to create a log object for the 'aClickSubmitUpmEvent' event (evid: 503)
 *
 * Event description: UOU click update in UPM checkout widget
 *
 * @param {aClickSubmitUpmEventParams} params - The parameters for this event
 * @property {GUID} sessionId - The session of UPM flow, can be multiple sessions for the same visitor (uou)
 * @property {GUID} subscriptionId - The subscription that the UOU is looking to update
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<aClickSubmitUpmEventParams>} LogObject<aClickSubmitUpmEventParams>
 */
export function aClickSubmitUpmEvent(params) {
    return { evid: 503, src: 128, endpoint: 'my-subscriptions', params: params };
}
/**
 * A function to create a log object for the 'aPaymentMethodUpdatedSuccessfully' event (evid: 504)
 *
 * Event description: UOU successfully updated payment method after success toast
 *
 * @param {aPaymentMethodUpdatedSuccessfullyParams} params - The parameters for this event
 * @property {GUID} subscriptionId - The subscription that the UOU is looking to update
 * @property {GUID} sessionId - The session of UPM flow, can be multiple sessions for the same visitor (uou)
 * @property {GUID} newPaymentMethodId - new_payment_method_id
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<aPaymentMethodUpdatedSuccessfullyParams>} LogObject<aPaymentMethodUpdatedSuccessfullyParams>
 */
export function aPaymentMethodUpdatedSuccessfully(params) {
    return { evid: 504, src: 128, endpoint: 'my-subscriptions', params: params };
}
/**
 * A function to create a log object for the 'aClickPayNowCtaEvent' event (evid: 506)
 *
 * Event description: UOU click on Submit Payment during grace period in order to pay and save his subscription before cancellation, the  payment method will be also updated for future payments on the subscription
 *
 * @param {aClickPayNowCtaEventParams} params - The parameters for this event
 * @property {DateTime} previousBillingDate - The previous date the subscription was charged at
 * @property {DateTime} nextBillingDate - The next date the subscription is scheduled to be charged at, in this case of grace period the value will be the failed date in the past
 * @property {GUID} subscriptionId - The subscription that the UOU is looking to pay
 * @property {string} subscriptionStatus - subscription status
 * @property {boolean} cycleAutoRenew - Flag indicating if the subscription will be canceled at the next cycle (at next_billing_date)
 * @property {number} cycle - Current cycle of subscription
 * @property {GUID} paymentMethodId - The current payment method before the update
 * @property {GUID} sessionId - The session of my subscriptions page, can be multiple sessions for the same customer, and multiple flows in the same session
 * @property {string} endPoint - end point
 * @return {LogObject<aClickPayNowCtaEventParams>} LogObject<aClickPayNowCtaEventParams>
 */
export function aClickPayNowCtaEvent(params) {
    return { evid: 506, src: 128, endpoint: 'my-subscriptions', params: params };
}
/**
 * A function to create a log object for the 'aClickCancelPayNowEvent' event (evid: 507)
 *
 * Event description: UOU cancel the Pay Now widget
 *
 * @param {aClickCancelPayNowEventParams} params - The parameters for this event
 * @property {GUID} subscriptionId - The subscription that the UOU is looking to pay
 * @property {string} referral - "Cancel Button" or Exit Window (click X or click in random place in screen)
 * @property {GUID} sessionId - The session of my subscriptions page, can be multiple sessions for the same customer, and multiple flows in the same session
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<aClickCancelPayNowEventParams>} LogObject<aClickCancelPayNowEventParams>
 */
export function aClickCancelPayNowEvent(params) {
    return { evid: 507, src: 128, endpoint: 'my-subscriptions', params: params };
}
/**
 * A function to create a log object for the 'aClickSubmitPayNowEvent' event (evid: 508)
 *
 * Event description: UOU click Submit in Pay Now flow
 *
 * @param {aClickSubmitPayNowEventParams} params - The parameters for this event
 * @property {string} paymentOrderId - payments identifier for the specific payment
 * @property {GUID} subscriptionId - The subscription that the UOU is looking to update
 * @property {GUID} sessionId - The session of my subscriptions page, can be multiple sessions for the same customer, and multiple flows in the same session
 * @property {string} assetVersion - indication - Cairo or old
 * @property {string} endPoint - end point
 * @return {LogObject<aClickSubmitPayNowEventParams>} LogObject<aClickSubmitPayNowEventParams>
 */
export function aClickSubmitPayNowEvent(params) {
    return { evid: 508, src: 128, endpoint: 'my-subscriptions', params: params };
}
/**
 * A function to create a log object for the 'aPayNowSuccessEvent' event (evid: 509)
 *
 * Event description: UOU successfully paid and updated payment method, and got success toast
 *
 * @param {aPayNowSuccessEventParams} params - The parameters for this event
 * @property {GUID} subscriptionId - The subscription that the UOU is looking to update
 * @property {GUID} sessionId - The session of UPM flow, can be multiple sessions for the same visitor (uou)
 * @property {GUID} newPaymentMethodId - new_payment_method_id
 * @property {string} endPoint - end point
 * @return {LogObject<aPayNowSuccessEventParams>} LogObject<aPayNowSuccessEventParams>
 */
export function aPayNowSuccessEvent(params) {
    return { evid: 509, src: 128, endpoint: 'my-subscriptions', params: params };
}
/**
 * A function to create a log object for the 'aPayNowSubmitResponseEvent' event (evid: 510)
 *
 * Event description: response from payments after UOU click submit in Pay Now flow
 *
 * @param {aPayNowSubmitResponseEventParams} params - The parameters for this event
 * @property {GUID} subscriptionId - The subscription that the UOU is looking to update
 * @property {string} response - ‘Approved’ | ‘Pending’ | ‘Failed’ | ‘InProcess’ | ‘Unknown’
 * @property {GUID} sessionId - The session of my subscriptions page, can be multiple sessions for the same customer, and multiple flows in the same session
 * @property {string} endPoint - end point
 * @return {LogObject<aPayNowSubmitResponseEventParams>} LogObject<aPayNowSubmitResponseEventParams>
 */
export function aPayNowSubmitResponseEvent(params) {
    return { evid: 510, src: 128, endpoint: 'my-subscriptions', params: params };
}
//# sourceMappingURL=index.js.map